angular.module('elfium').directive('dashboardTotalItem', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        replace: true,
        restrict: 'E',
        scope: {
        	count: '=',
            label: '@'
        },
        templateUrl: elfiumUrlService.getTemplateUrl('dashboard', 'dashboardTotalItem')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardTotalItem.ts